import { NgModule } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChartDirective } from './directives/chart.directive';
import * as enTranslations from './i18n/en-lang.json';

@NgModule({
  imports: [ChartDirective],
  exports: [ChartDirective],
})
export class ChartModule {
  constructor(private translate: TranslateService) {
    this.translate.setTranslation('en', enTranslations, true);
  }
}
